export function SectionDivider() {
  return (
    <div className="flex items-center justify-center gap-4 py-8" aria-hidden>
      <div className="h-[1px] w-16 bg-gradient-to-r from-transparent to-primary/40" />
      <div className="w-2 h-2 rotate-45 bg-primary/60" />
      <div className="h-[1px] w-16 bg-gradient-to-l from-transparent to-primary/40" />
    </div>
  );
}
